export const GET_MAIN_MENU_CONFIG = 'railsBuilder::GET_MAIN_MENU_CONFIG';
export const GET_MAIN_MENU_CONFIG_REQUEST =
    'railsBuilder::GET_MAIN_MENU_CONFIG_REQUEST';
export const GET_MAIN_MENU_CONFIG_SUCCESS =
    'railsBuilder::GET_MAIN_MENU_CONFIG_SUCCESS';
export const GET_MAIN_MENU_CONFIG_FAILURE =
    'railsBuilder::GET_MAIN_MENU_CONFIG_FAILURE';

export const GET_TEMPLATEVIEW = 'railsBuilder::GET_TEMPLATEVIEW';
export const GET_TEMPLATEVIEW_REQUEST =
    'railsBuilder::GET_TEMPLATEVIEW_REQUEST';
export const GET_TEMPLATEVIEW_SUCCESS =
    'railsBuilder::GET_TEMPLATEVIEW_SUCCESS';
export const GET_TEMPLATEVIEW_FAILURE =
    'railsBuilder::GET_TEMPLATEVIEW_FAILURE';
